export const defaultAttachmentDividerStyles = {
  margin: "0",
  height: "1px",
  border: "0px",
  backgroundColor: "#E8EAEC"
};